import { lang } from '../../assets/lang'

export const systemFieldOperators = [
  { key: 'equal', value: '&#61;' },
  { key: 'less_than', value: '&#60;' },
  { key: 'greater_than', value: '&#62;' },
  { key: 'greater_than_or_equal', value: '&#8805;' },
  { key: 'less_than_or_equal', value: '&#8804;' },
  { key: 'not_equal', value: '&#8800;' },
  { key: 'contains', value: lang.condition_html_operators_system_contains },
  { key: 'start_with', value: lang.condition_html_operators_system_start_with },
  { key: 'end_with', value: lang.condition_html_operators_system_end_with },
  { key: 'has_value', value: lang.condition_html_operators_system_has_value },
]

export const systemFieldVariables = [
  { key: 'gender', value: lang.condition_html_variables_system_gender },
  { key: 'first_name', value: lang.condition_html_variables_system_first_name },
  { key: 'last_name', value: lang.condition_html_variables_system_last_name },
  { key: 'contact_group_id', value: lang.condition_html_variables_system_contact_group_id },
  { key: 'email', value: lang.condition_html_variables_system_email },
  { key: 'phone_number', value: lang.condition_html_variables_system_phone_number },
]







